import { useState } from "react";

import { Flex, Text, Box, Table } from "flicket-ui";

import { ContentModal } from "~components";
import { Row } from "~components/events/events.Row";
import { ZonedDate } from "@flicket/utils";
import { MembershipQuery } from "~graphql/sdk";
import { useOrganization } from "~hooks";
import { i18n } from "~lib";
import { formatEventDateRange } from "~lib/helpers/formatDate";

type ScheduleProps = Pick<
  MembershipQuery["membership"],
  "events" | "showSchedule"
>;

type ActiveEvent = ScheduleProps["events"][number];

export const Schedule = ({ events, showSchedule }: ScheduleProps) => {
  const [activeEvent, setActiveEvent] = useState<ActiveEvent>();

  const orderedEvents = events;

  orderedEvents.sort(function (a, b) {
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  });

  return (
    <Box w="100%">
      <Flex
        w="100%"
        pb="6/4"
        borderBottom="1px solid"
        borderColor="N200"
        justifyContent="space-between"
        alignItems="center"
        d={{ _: "flex", md: "none !important" }}
      >
        <Text
          lineHeight="medium"
          fontWeight="extraBold"
          fontSize={3}
          color="N800"
        >
          Upcoming Events
        </Text>
      </Flex>
      {showSchedule ? (
        <>
          <Table
            data={orderedEvents}
            row={(event: ActiveEvent) => (
              <Row
                // @ts-expect-error changed in a following PR
                onClick={() => setActiveEvent(event)}
                disableRedirectToEvent
                bg="white"
                {...event}
              />
            )}
          />
        </>
      ) : (
        <Text
          lineHeight="medium"
          fontWeight="extraBold"
          fontSize={3}
          color="N800"
          textAlign={"center"}
        >
          Schedule coming soon!
        </Text>
      )}
      <ContentModal
        isOpen={!!activeEvent?.title}
        setIsOpen={() => setActiveEvent(undefined)}
        title={activeEvent?.title}
        image={activeEvent?.logo}
        richText={activeEvent?.description}
        subtitle={activeEvent?.venue?.name}
        location={activeEvent?.venue?.name}
        date={formatEventDateRange(
          activeEvent?.startDate,
          activeEvent?.endDate as string,
          {
            format: "basicShort",
            timeZone: activeEvent?.venue?.timezone,
            locale: activeEvent?.venue?.locale,
          }
        )}
      />
    </Box>
  );
};
